import { useState } from 'react'
import { Send } from 'lucide-react'
import { receiptOptions } from './helper'
import Item from './Item'
import { Button } from 'components/Button'
import { getPatient } from 'library/auth';
import { TreatmentPlansActions } from 'store/actions';
import { connect } from 'react-redux';
import toast from 'react-hot-toast'

let enhancer = connect(null, { ...TreatmentPlansActions });

const ReceiptStep = ({ treatmentPlanId, onNext, sendReceipt }) => {
  const patient = getPatient();
  const [selectedOption, setSelectedOption] = useState<'email' | 'none'>('email')
  const [email, setEmail] = useState(patient.email || '')
  const [loading, setLoading] = useState(false)

  const loadTreatmentPlan = async () => {
    if (selectedOption == 'none') {
      onNext()
      return
    }

    if (!email) {
      toast.error('Please provide an email address');
      return
    }

    setLoading(true)
    try {
      await sendReceipt(treatmentPlanId, { patient_email: email });
      toast.success('Receipt sent successfully');
      onNext();
    } catch (error) {
      toast.error(error?.errors || 'Failed to send receipt');
    } finally {
      setLoading(false)
    }
  };

  return (
    <div className="w-full space-y-6 py-4">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-50 text-blue-600 mb-1">
          <Send size={20} />
        </div>
        <h2 className="text-lg font-bold text-secondary-900">How would you like your receipt?</h2>
        <p className="text-xs text-secondary-500 max-w-md mx-auto">Select your preferred delivery option.</p>
      </div>

      <div className="w-full lg:max-w-[60%] mx-auto mt-6">
        {receiptOptions.map((option) => (
          <Item
            key={option.key}
            option={
              option.key === 'email'
                ? { ...option, input: { value: email, onChange: setEmail } }
                : option
            }
            isSelected={selectedOption === option.key}
            onSelect={() => setSelectedOption(option.key)}
          />
        ))}

        <div className="flex justify-center mt-6">
          <Button
            title={selectedOption === 'none' ? "Next" : "Send Receipt"}
            variant="tertiary"
            className='px-32'
            onClick={loadTreatmentPlan}
            loading={loading}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  )
}

export default enhancer(ReceiptStep)
